module.exports = __webpack_public_path__ + "static/media/andreasRZiegler.524f0e7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/andreasRZiegler.jpg
// module id = 1665
// module chunks = 1